import { Container, SubTitle, InfoText, MoneyTextMask } from './styles'

export default function Business ({ data: business }) {
  return (
    <Container>
      <SubTitle style={{justifySelf: 'flex-start', textAlign: 'left'}}>
        {business.name}
      </SubTitle>
      <InfoText>
        {business.totalSchedules}
      </InfoText>
      <MoneyTextMask value={business.totalEarned} style={{justifySelf: 'flex-end'}}/>
    </Container>
  )
}
